import {
	WIDGET_FETCH,
	WIDGET_SUCCESS,
	WIDGET_FAILURE,
	WIDGET_RESET_ALL,
	WIDGET_DELETE,
	WIDGET_REFRESH
} from 'Actions/WidgetActions';

import {
	FORUM_FOLLOWING,
	THREAD_FOLLOWING
} from 'Actions/ForumviewActions';

const initialState = {
		widgets: {}
	},
	widgetInitialState = {
		name: 'w1',
		isFetching: false,
		loaded: false,
		refresh: 0, // Triggers widget refresh
		beenUpdated: 0, // Indicates update in data
		lastError: '',
		itemId: 0,
		entities: {},
		result: {
			forums: [],
			posts: [],
			topics: [],
			users: [],
			pms: [],
			pmfolders: [],
			attachments: []
		},
		otherParams: {}
	};

export default function widgetState( prevState = initialState, action ) {
	let newState = prevState,
		newWidgets = Object.assign( {}, prevState.widgets ),
		widget = {},
		newUpdate = new Date().getTime();

	switch( action.type ) {
		case WIDGET_FETCH:
			widget = Object.assign( {}, widgetInitialState, {
				name: action.name,
				loaded: false,
				isFetching: true
			} );

			if( newWidgets[ action.name ] ) {
				widget = Object.assign( {}, newWidgets[ action.name ], {
					loaded: true,
					isFetching: true,
					lastError: ''
				} );
			}

			newWidgets[ action.name ] = widget;
			return Object.assign( {}, prevState, { widgets: newWidgets } );

		case WIDGET_SUCCESS:
			newWidgets[ action.name ] = Object.assign( {}, widgetInitialState, action.data, {
				name: action.name,
				loaded: true,
				isFetching: false
			} );

			return Object.assign( {}, prevState, { widgets: newWidgets } );

		case WIDGET_DELETE:
			// delete the widget if it's in the state
			if( newWidgets[ action.name ] ) {
				delete newWidgets[ action.name ];
				newState = Object.assign( {}, prevState, { widgets: newWidgets } );
			}

			return newState;

		case WIDGET_REFRESH:
			if( action.name === '' ) { // refresh all
				Object.keys( newWidgets ).forEach( ( w ) => {
					if( newWidgets[ w ].isFetching === false ) { // skip if we are fetching
						newWidgets[ w ] = Object.assign( {}, newWidgets[ w ], {
							refresh: newUpdate,
							isFetching: true
						} );
					}
				} );

				return Object.assign( {}, prevState, { widgets: newWidgets } );

			} else if( action.name && newWidgets[ action.name ] ) { // refresh passed widget by name
				if( newWidgets[ action.name ].isFetching === false ) { // skip if we are fetching
					newWidgets[ action.name ] = Object.assign( {}, newWidgets[ action.name ], {
						refresh: newUpdate,
						isFetching: true
					} );
				}

				return Object.assign( {}, prevState, { widgets: newWidgets } );
			}

			return prevState;

		case WIDGET_RESET_ALL:
			return initialState;

		case WIDGET_FAILURE:
			newWidgets[ action.name ] = Object.assign( {}, widgetInitialState, action.data, {
				name: action.name,
				loaded: false,
				isFetching: false,
				lastError: action.error
			} );

			return Object.assign( {}, prevState, { widgets: newWidgets } );


		//Supporting Follow/UnFollow threads and forums
		case FORUM_FOLLOWING:
			Object.keys( newWidgets ).forEach( ( w ) => {
				let prevEntitiesForum = newWidgets[ w ].entities.forums,
					forum = newWidgets[ w ].entities.forums[ action.forumId ];

				forum.isSubscribed = action.follow;
				let entitiesForum = {
					forums: Object.assign( {}, prevEntitiesForum, { [ action.forumId ]: forum } ),
					beenUpdated: newUpdate
				};
				newWidgets[ w ] = Object.assign( {}, newWidgets[ w ], entitiesForum );
			} );

			return Object.assign( {}, prevState, { widgets: newWidgets } );

		case THREAD_FOLLOWING:
			let prevEntitiesThread = {}, thread = {}, entities = true;
			Object.keys( newWidgets ).forEach( ( w ) => {
				entities = true;
				if( newWidgets[ w ].entities.topics && newWidgets[ w ].entities.topics[ action.threadId ] ) {
					entities = 'topics';
				} else if( newWidgets[ w ].entities.sticky && newWidgets[ w ].entities.sticky[ action.threadId ] ) {
					entities = 'sticky';
				} else {
					entities = false;
				}
				if( entities ) {
					prevEntitiesThread = newWidgets[ w ].entities[ entities ];
					thread = newWidgets[ w ].entities[ entities ][ action.threadId ];
					thread.isSubscribed = action.follow;

					let entitiesThreads = {
						[ entities ]: Object.assign( {}, prevEntitiesThread, { [ action.threadId ]: thread } ),
						beenUpdated: newUpdate
					};
					newWidgets[ w ] = Object.assign( {}, newWidgets[ w ], entitiesThreads );
				}
			} );

			return Object.assign( {}, prevState, { widgets: newWidgets } );

		default :
			return prevState;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/widgetReducer.js